<template lang="pug">
.main-content
  .form-group
    label.col-md-12 寸法
    .col-md-12
      el-input(type='text',value='', v-model='scochGunData.size')
  .form-group
    label.col-md-12 寸法備考
    .col-md-12
      el-input(type='text',value='', v-model='scochGunData.size_ext')
  .form-group
    label.col-md-12 重量
    .col-md-12
      el-input(type='text',value='', v-model='scochGunData.weight')
  .form-group
    label.col-md-12 重量備考
    .col-md-12
      el-input(type='text',value='', v-model='scochGunData.weight_ext')
  .form-group
    label.col-md-12 品名
    .col-md-12
      el-input(type='text',value='', v-model='scochGunData.item_name')
  .form-group
    label.col-md-12 品名備考
    .col-md-12
      el-input(type='text',value='', v-model='scochGunData.item_name_ext')
  .form-group
    label.col-md-12  品番
    .col-md-12
      el-input(type='text',value='', v-model='scochGunData.item_number')
  .form-group
    label.col-md-12  品番備考
    .col-md-12
      el-input(type='text',value='', v-model='scochGunData.item_number_ext')
  .form-group
    label.col-md-12  ノズル口径
    .col-md-12
      el-input(type='text',value='', v-model='scochGunData.nozzle_calber')
  .form-group
    label.col-md-12  ノズル口径備考
    .col-md-12
      el-input(type='text',value='', v-model='scochGunData.nozzle_calber_ext')
  .form-group
    label.col-md-12 エアキャップ仕様
    .col-md-12
      el-input(type='text',value='', v-model='scochGunData.air_cap.spec')
  .form-group
    label.col-md-12 エアキャップ備考
    .col-md-12
      el-input(type='text',value='', v-model='scochGunData.air_cap.remark')
  .form-group
    label.col-md-12 エア使用量
    .col-md-12
      el-input(type='text',value='', v-model='scochGunData.air_amount')
  .form-group
    label.col-md-12 エア使用量備考
    .col-md-12
      el-input(type='text',value='', v-model='scochGunData.air_amount_ext')
  .form-group
    label.col-md-12 ボディ材質
    .col-md-12
      el-input(type='text',value='', v-model='scochGunData.body_material')
  .form-group
    label.col-md-12 ボディ材質備考
    .col-md-12
      el-input(type='text',value='', v-model='scochGunData.body_material_ext')
  .form-group
    label.col-md-12 対応塗料
    .col-md-12
      el-input(type='text',value='', v-model='scochGunData.paint')
  .form-group
    label.col-md-12 対応塗料備考
    .col-md-12
      el-input(type='text',value='', v-model='scochGunData.paint_ext')

</template>


<script>
export default {
  name: 'ScochGun',
  data () {
    return {
    }
  },
  props: {
    scochGunData: Object
  },
  created () {
  },
  methods: {
  }
}
</script>

<style lang="scss", scoped>
.hidden {
  visibility: hidden;
}

*:focus {
  outline: 0
}
</style>



// WEBPACK FOOTER //
// src/views/components/swan/techInfo/ScochGun.vue